import React, { useState } from 'react';
import staffApi from '../../staffApi';

export default function SendLinkModal({ test, onClose }) {
  const [tutorEmail, setTutorEmail] = useState('');
  const [tutorName, setTutorName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tutorEmail.trim()) {
      alert('Please enter tutor email');
      return;
    }

    try {
      setLoading(true);
      await staffApi.sendTestLink(test.id, tutorEmail, tutorName);
      alert('Test link sent successfully!');
      setTutorEmail('');
      setTutorName('');
      onClose();
    } catch (error) {
      console.error('Error sending link:', error);
      alert('Failed to send test link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">Send Test Link</h2>
        <p className="text-sm text-gray-600 mb-4">Test: {test.title}</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tutor Email *
            </label>
            <input
              type="email"
              value={tutorEmail}
              onChange={(e) => setTutorEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tutor Name (optional)
            </label>
            <input
              type="text"
              value={tutorName}
              onChange={(e) => setTutorName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>

          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Link'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

